<!-- 角色管理 -->
<style lang="less">
    #roleManager{
    	.query-bar{
    		background: transparent;
    		height: 80px;
    		padding-top: 20px;
    		margin-bottom: 30px;
    		border-bottom: 1px solid #e9eaec;
    	}
    	table{
    		text-align: center;
    		th{
    			height: 50px;
    			font-size: 16px;
    		}
    		th,td{
    			text-align: center;
    		}
    	}
    	.ivu-page{
	    	margin-top: 30px;
	    }
    	.rightTop{
    		h4{
    			font-size: 18px;
    			color: #45AAF9;
    			float: left;
    			text-align: left;
    		}
    		text-align: left;
    		.ivu-form-item{
    			text-align: left;
    		}
    	}
        .ivu-input-type{
            .ivu-input{
                height: 32px!important
            }
        }
        .addBtn{
            margin-top: 5px;
            margin-bottom: 5px;
        }
        .ml32{
            height: 36px;
            line-height: 36px;
        }
    }
</style>


<template>
    <div id="roleManager">
        <i-col span="24" style="padding: 0 20px;">
            <div class="query-bar">
                <Form ref="formInline" class="rightTop" :model="formInline" inline :label-width="80">
                	<h4>角色管理</h4>
                    <Button style="margin-top: 0;margin-left: 20px;" class="addBtn" @click="addRole" type="primary">新增角色</Button>
                    <Form-item label="角色名称" prop="rolename">
                        <Input  v-model="formInline.rolename" placeholder="请输入角色名称" long></Input>
                    </Form-item>
                    <Form-item label="角色描述" prop="description">
                        <Input  v-model="formInline.description" type="textarea" placeholder="请输入..." ></Input>
                    </Form-item>
                    <Button type="primary" @click="submitSearch(actionPage)">搜索</Button>

                </Form>
            </div>
            <Modal v-model="modal1">
                <div slot="header">{{updateTitle}}</div>
                <Form ref="roleForm" :model="formItem" :label-width="80" :rules="role_validate_rules">
                    <Form-item label="角色名称" prop="rolename">
                        <Input v-model="formItem.rolename" @on-blur="checkName('name')" class="width90" :maxlength="8" placeholder="请输入角色名称" long></Input>
                    </Form-item>
                    <Form-item label="角色描述" prop="description">
                        <Input v-model="formItem.description" type="textarea" class="width90" :rows="4" placeholder="请输入..."></Input>
                    </Form-item>
                    <Form-item label="隶属部门" prop="department">
                        <Select :value="formItem.department.code" @on-change="setRoleDepartment">
                            <Option v-for="item in departments" :key="item.code" :value="item.code">{{item.name}}</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="角色用户" >
                        <Select multiple v-model="users"  >
                            <Option v-for="item in usresList" :value="item.username" :key="item.realname">{{item.realname}}</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="角色权限" prop="modules" class="roleTree">
                        <Tree v-if="treeShow" :data="formItem.modules" show-checkbox></Tree>
                    </Form-item>
                    <Form-item label="功能权限" prop="menus" class="roleTree">
                        <Tree v-if="treeShow2" :data="formItem.menus" show-checkbox></Tree>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button v-if="btnSave" type="primary" @click="confirmAddRole('roleForm')">保存</Button>
                    <Button v-if="btnChange" type="primary" @click="modifyRole('roleForm')">修改</Button>
                    <Button  @click="cancel">取消</Button>
                </div>
            </Modal>
            <div class="center">
                <Table ref="table" :data="roleData" :columns="theadArr" stripe></Table>
                <Page class="pull-right" :total="totalSize" :current="page" :page-size = "pageSize" show-total @on-change="changePage"></Page>
            </div>
        </i-col>
    </div>
</template>


<script>
    export default {
        data () {
            const reEXP_roleName = /^[\u4e00-\u9fa5]+$/;//匹配rolename只能为中文
            const validate_rolename =  (rule,value,callback) =>{
                if(!reEXP_roleName.test(value)){
                    callback(new Error('角色名称只能为不含数字的汉字！'))
                }else {
                    callback();
                }
            };
            const validate_department = (rule,value,callback) =>{
                console.log(value);
                if(value.code == '') {
                    callback(new Error('所属部门不能为空！'))
                }else {callback()}
            };
            return {
                role_validate_rules:{
                    rolename:[{ required: true, message: '角色名称不能为空！', trigger: 'blur' },{validator:validate_rolename,trigger:'blur'}],
                    department:[{required:true,validator:validate_department,trigger:'change'}],
                },
                urlRoleList2:"/sys/role/list",
                urlRoleList:'/sys/role/list?system_id="1000000"',
                urlRoleAddList:'/sys/role/new',
                urlRoleUpdateList:'/sys/role/edit',
                urlRoleDeleteList:'/sys/role/delete',
                urlModuleList: "/sys/module/getallinlevels",
                updateTitle:"",
                treeShow: false,
                treeShow2: false,
                theadArr: [{
                    title: "角色名称",
                    width: 500,
                    key: "rolename"
                }, {
                    title: "权限描述",
                    key: "description"
                }, {
                    title: '用户操作',
                    align: 'center',
                    width: 200,
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginRight : '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row,params.index)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                },
                                style: {
                                    marginRight : '5px'
                                },
                                on: {
                                    click: () => {
                                        //this.del(params.index)
                                        this.delRole(params.row)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }],
                btnSave: false,
                btnChange: false,
                modal1: false,
                modal2: false,
                delIndex: "",
                actionPage: 1,
                roleData:[],
                usresList:[],
                users:[],
                formItem: {rolename:'',description:'',modules: [],menus: [],department:{code:''}},
                formInline: {
                    rolename:'',
                    description:'',
                },
                totalSize:0,//总条数
                pageSize:10,//每页显示数
                page:1,//当前页
                departments:''
            }
        },
        methods: {
//        	changQuery(){
//        		this.submitSearch(this.actionPage)
//        	},
            /*获取人员*/
            getPeople(){
                var that = this;
                this.usresList = [];
                var params = {};
                params.url = '/sys/userinfo/list';
                params.data ={};
                params.token = window.localStorage.getItem("token");
                params.success = function (res) {
                    res = res.data;
                    if(res.code = '0000'){
                        console.log(res);
                        var data = res.result.result;
                        data.map((item) =>{
                            that.usresList.push(item);
                        })

                    }else{
                      that.$Message.error({
                        content: res.message
                      });
                    }
                };
                this.ajaxPost(params)
            },

            submitSearch: function (page) {
                page = page == "" || page == undefined ? this.page:page;
                var that = this;
                var params = {};
                params.data = {page,pageSize : this.pageSize, order : {"_id":-1}, searchValue : {}};
                params.token = window.localStorage.getItem("token");
                params.url = this.urlRoleList;
                if(this.formInline.rolename !=''){
                    params.data.searchValue.rolename = this.formInline.rolename+"|#|like";
                }
                if(this.formInline.description !=''){
                    params.data.searchValue.description = this.formInline.description+"|#|like";
                }
                params.success = function(res) {
                    res = res.data
                    that.$Loading.finish();
                    that.roleData = res.result.result;
                    that.totalSize = res.result.totalSize;
                    that.page = res.result.page;

                }
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.submitSearch(page);
                this.actionPage = page;
            },
            addRole: function() {
                var that = this;
                var params = {};
                this.formItem = {department:{code:''},modules: [],menus: [],description:'',rolename:''};
                this.users=[];
                params.data = {
                    searchValue : {}
                }
                params.token = window.localStorage.getItem("token");
                params.url = this.urlModuleList;
                params.success = function(res) {
                    res = res.data;
                    that.formItem.modules = res.result.result.modules;
                    that.treeShow = true;
                    that.showThree2();

                }
                this.ajaxPost(params);
                this.updateTitle = "新增角色";
                this.btnChange = false;
                this.btnSave = true;
                this.modal1 = true;
            },
            showThree2(){
                var that = this;
                var params = {};
                params.data = {};
                params.token = window.localStorage.getItem("token");
                params.url = "/sys/menus/getmenustree";
                params.success = function(res) {
                    res = res.data;
                    that.formItem.menus = [{
                        title :"所有功能",
                        children : res.result
                    }]
                    that.treeShow2 = true;
                }
                this.ajaxPost(params);
            },
            //确定保存新增角色
            confirmAddRole (formName) {
                let that = this;
                this.$refs[formName].validate((valid) =>{
                    if(valid) {
                        let params = {};
                        let arr=[]
                        console.log(that.users);
                        params.url = that.urlRoleAddList;
                        params.data = that.formItem;
                        that.usresList.map(item =>{
                            let obj={};
                            for(let i in that.users){
                                if(item.username==that.users[i]){
                                    obj.realname=item.realname;
                                    obj.username=item.username;
                                    arr.push(obj)
                                }
                            }

                        })
                        params.data.users=arr;
                        params.data.menus = params.data.menus[0].children;
                        params.token = window.localStorage.getItem("token");
                        params.success=function(res){
                            res = res.data;
                            if(res.code == '0000') {
                                that.$Message.success({
                                    content: '新增成功'
                                });
                                that.submitSearch(parseInt(that.actionPage));
                                that.modal1=false;
                            }
                        }
                        params.error = function (res) {
                            res = res.data
                          console.log(res)
                        }
                        that.ajaxPost(params);
                    }
                })
            },
            //删除角色
            delRole: function(data) {
                let that = this;
                this.$Modal.confirm(
                   {
                      content:'确认删除该个角色？',
                      onOk:function () {
                          let params = {};
                          params.data = {'_id':data['_id'].toString(),"roleid":data.roleid};
                          params.url = that.urlRoleDeleteList;
                          params.token = window.localStorage.getItem("token");
                          params.success=function(res){
                              res = res.data
                              switch(res.code) {
                                  case '0000':
                                      if(res.message =='该角色已绑定用户，请先删除用户'){
                                          console.log(":123");
                                          that.$Message.success({
                                              content: '该角色已绑定用户，请先删除用户'
                                          });
                                          return;
                                      }
                                      that.$Message.success({
                                           content: '删除成功'
                                      });
                                      break;
                                  default:
                                      that.$Message.warning({
                                          content: res.message + " 删除失败"
                                      });
                              }

                              that.submitSearch(parseInt(that.actionPage));
                        }
                        that.ajaxPost(params);
                      }
                   }
                )
            },
            cancel () {
                this.modal1=false;
            },
            edit: function(row,index) {
                let that = this;
                this.modal1 = true;
                this.updateTitle = "编辑角色";
                this.users=[];
                this.formItem = JSON.parse(JSON.stringify(row));
                delete this.formItem['_index'];
                delete this.formItem['_rowKey'];
                let params = {};
                params.data = {searchValue:{"roleid":row.roleid}}
                params.url = '/sys/role/getbyid';
                params.token = window.localStorage.getItem("token");
                params.success = function (res) {
                    res = res.data;
                    console.log(res);
                    console.log(res.result);
                    if(res.code == '0000'){
                        that.formItem.modules = res.result.result[0].modules;
                        that.formItem.menus = res.result.result[0].menus;
                        that.users = res.result.result[0].users;
                        res.result.result[0].users.map(item=>{
                            that.users.push(item.username)
                        })
                        that.treeShow2 = true;

                    }else{
                      that.$Message.error({
                        content: res.message
                      });
                    }
                }
                this.ajaxPost(params)
                this.btnSave = false;
                this.btnChange = true;
                this.treeShow = true;

            },
            //确定修改角色
            modifyRole: function(formName) {
                let that = this;
                this.$refs[formName].validate((valid) =>{
                    if(valid) {
                        let params = {};
                        let arr=[]
                        params.url = that.urlRoleUpdateList;
                        params.data = that.formItem;
                        that.usresList.map(item =>{
                            let obj={};
                            for(let i in that.users){
                                if(item.username==that.users[i]){
                                    obj.realname=item.realname;
                                    obj.username=item.username;
                                    arr.push(obj)
                                }
                            }

                        })
                        console.log("params is",params);
                        params.data.users=arr;
                        console.log("data is",params.data);
                        params.token = window.localStorage.getItem("token");
                        params.success=function(res){
                            res = res.data;
                            if(res.code == '0000') {
                                that.$Message.success({
                                    content: '修改成功'
                                });
                                that.submitSearch(parseInt(that.actionPage));
                                that.modal1=false;
                            }else{
                              that.$Message.error({
                                content: res.message
                              });
                            }
                        }
                        that.ajaxPost(params);
                    }
                })
            },
            checkName: function(data) {
                var that = this;
                var params = {};
                params.data = {searchValue:{}}
                if( data === "name"){
                    if(this.formItem.rolename === ""){return};
                    params.data.searchValue.rolename = this.formItem.rolename;
                }
                params.url = this.urlRoleList2;
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    res = res.data;
                    if(parseInt(res.result.totalSize) !== 0){
                        that.$Message.warning({
                            content: '已被注册'
                        });
                    }else{
                        that.$Message.success({
                            content: '可用'
                        });
                    }
                }
                this.ajaxPost(params);
            },
           //获取部门
           getDepartments:function () {
               let params = {};
               let that = this;
               params.data = {};
               params.token = window.localStorage.getItem("token");
               params.url = '/sys/department/list';
               params.success = function (res) {
                   res = res.data;
                   if(res.code == '0000'){
                       that.departments = res.result.result;
                   }
               };
               this.ajaxPost(params)
           },
           //设置角色的部门
           setRoleDepartment:function (data) {
                let that = this;
               this.departments.map((item) =>{
                   if(item.code == data){
                       that.$set(that.formItem,'department',item);
                   }
               })
           }
        },
        mounted: function() {
            this.submitSearch();
            this.getDepartments();
            this.getPeople()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/userMana/role.vue